/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { Component } from 'react';
import { Layout, Menu, Icon } from 'antd';
import { withRouter } from 'react-router';
import styles from './side-menu.styles';

const IconFont = Icon.createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/font_1284029_o1wb277rbnn.js',
});

export class SideMenuComponent extends Component {
  renderIcon = (route) => {
    const { icon } = route;

    const props = ({
      theme: 'outlined',
      ...icon,
      css: icon && icon.css ? css(icon.css) : null,
    });

    if (props.lib === 'fontawesome') {
      return (
        <span css={css(styles.faContainer)}>
          <i {...props} className={`fas fa-${props.type}`} />
        </span>
      );
    } else if (props.lib === 'iconfont') {
      return <IconFont {...props} />;
    }
    return <Icon {...props} />;
  };
  render() {
    const { routes, changeRoute, currentRoute } = this.props;

    const matchPath = (currentRoute && (currentRoute.highlighted || currentRoute.path)) || '';
    const selectedKeys = routes
      .map((r, i) => (matchPath && matchPath === r.path ? i.toString() : null))
      .filter(r => r !== null);

    return (
      <Layout.Sider className="no-print" width={200} css={css(styles.container)}>
        <Menu
          mode="inline"
          selectedKeys={selectedKeys}
          style={{ height: '100%', borderRight: 0 }}
        >
          {routes.map((route, i) => {
            return (
              <Menu.Item css={css(styles.liContainer)} key={i} onClick={() => changeRoute(route)}>
                {route.icon && (
                  <span
                    css={css`
                      margin-right: 0px;
                    `}
                  >
                    {this.renderIcon(route)}
                  </span>
                )}
                <span css={css(styles.title)}>{route.title}</span>
              </Menu.Item>
            );
          })}
        </Menu>
      </Layout.Sider>
    );
  }
}

export const SideMenu = withRouter(SideMenuComponent);
